<template>
  <v-card class="actor" color="white">
    <v-img
      contain
      :src="actor.imageUrl"
      height="150px"
      aspect-ratio="1"
    ></v-img>
    <v-card-title primary-title>
      {{ actor.name }}
    </v-card-title>
    <v-spacer></v-spacer>
    <v-card-actions>
      <v-btn color="deep-purple lighten-2" text @click="remove"> Remove </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import environment from "../../env";
export default {
  mounted() {
    this.getActor();
  },
  data: () => {
    return {
      actor: {},
    };
  },
  props: {
    actorId: {
      type: Number,
    },
  },
  //   watch: {
  //     actorId: function () {
  //       console.log("term changed");
  //       this.getActor();
  //     },
  //     deep: true,
  //   },
  methods: {
    remove() {
      console.log("removing");
      this.$emit("id", null);
    },
    getActor() {
      console.log("getting actorrrrr");
      axios
        .get(
          `https://api.themoviedb.org/3/person/${this.actorId}?api_key=${environment.APIKEY}&language=en-US`
        )
        .then((res) => {
          console.log("the actor", res);
          this.actor = {
            id: res.data.id,
            name: res.data.name,
            image: res.data.profile_path,
            imageUrl: res.data.image
              ? "https://eu.ui-avatars.com/api/?name=" + res.data.name
              : "https://image.tmdb.org/t/p/w185" + res.data.profile_path,
          };
        });
    },
  },
};
</script>

<style scoped>
.v-card__title {
  word-break: normal; /* maybe !important  */
}
</style>